interface Props {
  readonly size: number;
}

export default function ParadexIcon(props: Props) {
  const { size } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5a5 5 0 0 1 5-5h22a5 5 0 0 1 5 5v22a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z"
        fill="#07071D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m21.02 11.76 1.92 2.95h-1.82L19.3 11.9h-2.5v-1.47h3.38c.66 0 1.2-.5 1.2-1.12 0-.31-.14-.6-.36-.8-.21-.2-.51-.32-.84-.32H16.8V6.7h3.38a2.86 2.86 0 0 1 2.33 1.2 2.46 2.46 0 0 1 .17 2.52 2.73 2.73 0 0 1-1.65 1.34ZM14.77 7.9c-.1-.16-.23-.3-.37-.44-.5-.47-1.2-.76-1.96-.76H9.05v1.48h3.38c.33 0 .63.12.84.32.22.2.35.49.35.8 0 .61-.53 1.12-1.2 1.12H9.07v4.29h1.48V11.9h1.9c1.1 0 2.05-.6 2.5-1.47a2.44 2.44 0 0 0-.17-2.52Zm8.17 8.4h-1.8l-1.7 2.6-1.69-2.6h-1.8l2.59 4-2.6 4h1.81l1.7-2.6 1.68 2.6h1.81l-2.6-4 2.6-4Zm-7.81 4a4 4 0 0 1-3.97 4h-2.1v-1.47h2.1a2.5 2.5 0 0 0 2.5-2.53 2.53 2.53 0 0 0-2.5-2.53h-2.1V16.3h2.1c2.2 0 3.97 1.79 3.97 4Z"
        fill="#fff"
      />
    </svg>
  );
}
